import { categories } from "@/mocks/products";

export default function CategorySection() {
  return (
    <section className="py-6 md:py-8 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between mb-4 md:mb-5">
          <h2 className="text-lg md:text-xl font-bold text-gray-900" style={{ fontFamily: "'Noto Serif SC', serif" }}>
            商品分类
          </h2>
          <button className="text-red-500 text-sm hover:underline cursor-pointer whitespace-nowrap">
            查看全部 <i className="ri-arrow-right-s-line"></i>
          </button>
        </div>
        <div className="grid grid-cols-5 sm:grid-cols-5 lg:grid-cols-10 gap-2 md:gap-3">
          {categories.map((cat) => (
            <button
              key={cat.id}
              className="flex flex-col items-center gap-1.5 md:gap-2 p-2 md:p-3 rounded-xl hover:bg-red-50 transition-colors cursor-pointer group"
            >
              <div className={`w-11 h-11 md:w-14 md:h-14 flex items-center justify-center rounded-full ${cat.color} overflow-hidden`}>
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-xs text-gray-600 group-hover:text-red-500 transition-colors font-medium whitespace-nowrap">
                {cat.name}
              </span>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
